const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <a className="footer-brand" href="#/" aria-label="Veda Glow home">
            <img src="/veda-glow-logo.svg" alt="Veda Glow" />
          </a>
          <p>Premium Indian skincare crafted for calm, hydrated, naturally luminous skin.</p>
        </div>

        <div>
          <h3>Quick Links</h3>
          <a href="#/shop">Shop</a>
          <a href="#/products">Products</a>
          <a href="#/">Clients</a>
        </div>

        <div>
          <h3>Policies</h3>
          <span>Shipping across India</span>
          <span>Easy returns</span>
          <span>Privacy first</span>
        </div>

        <div>
          <h3>Contact</h3>
          <span>hello@vedaglow.com</span>
          <span>Instagram</span>
          <span>Visa / Mastercard / UPI</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
